import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { FormService } from '../services/form.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { ResultService } from '../services/result.service';

@Component({
  selector: 'app-offline-form',
  templateUrl: './offline-form.component.html',
  styleUrls: ['./offline-form.component.scss']
})
export class OfflineFormComponent implements OnInit {

  public decidir: any;
  public decidirInstance = null;
  public formSubmitted = false;
  public formPromise: Observable<any>;
  private routeParams: any = null;

  registerForm: FormGroup;
  submitted = false;

  constructor(
    private formService: FormService,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private result: ResultService,
    private router: Router
  ) {
    this.route.params.subscribe(params => {
      this.routeParams = params;
    });
    sessionStorage.setItem('type', 'pago-mis-cuentas');
  }

  ngOnInit() {
    this.initDecidir();
    this.registerForm = this.formBuilder.group({
      name: [
        '',
        [
          Validators.required,
          Validators.pattern(
            '^[\u00F1A-Za-z _]*[\u00F1A-Za-z][\u00F1A-Za-z _]*$'
          )
        ]
      ],
      document: [
        '',
        [
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(8),
          Validators.pattern('^([0-9])*$')
        ]
      ],
      email: [
        '',
        [
          Validators.required,
          Validators.pattern(
            '[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,64}'
          )
        ]
      ],
      bank: ['', [Validators.required]],
      typeDoc: ['dni']
    });
  }
  get f() {
    return this.registerForm.controls;
  }

  private initDecidir() {
    if (!!window['Decidir']) {
      this.decidir = window['Decidir'];
      this.decidirInstance = new this.decidir(
        environment.settings.UrlDecidir,
        true
      );
      this.decidirInstance.setTimeout(5000);
      this.decidirInstance.setPublishableKey(
        environment.settings.DecidirPublicKey
      );
    }
  }

  public doPayOffline(event: Event) {
    this.submitted = true;
    if (this.registerForm.invalid) {
      return false;
    }
    event.preventDefault();

    const data = {
      customer: {
        name: this.registerForm.controls.name.value,
        bank_id: this.registerForm.controls.bank.value,
        identification: {
          type: this.registerForm.controls.typeDoc.value,
          number: this.registerForm.controls.document.value
        }
      }
    }
    this.formService.paywayTokenizeOffline(data).subscribe((response: any) => {
      if (response && response.id) {
        this.sdkResponseHandler(response);
      } else {
        this.goToError();
      }
    }, () => { this.goToError() })
    return false;
  }

  public sdkResponseHandler(response) {
    const requestBody = {
      id: response.id,
      email: this.registerForm.value.email,
      trx: this.routeParams.trx,
      customerName: this.registerForm.value.name,
      customerIdentificationNumber: this.registerForm.value.document,
      customerIdentificationType: this.registerForm.value.typeDoc,
      banco: this.registerForm.value.bank
    };
    this.formSubmitted = true;
    this.result.formPromise = this.formService.makeOfflinePayment(requestBody);

    this.router.navigateByUrl('form/result');
  }

  private goToError() {
    this.formSubmitted = true;
    this.result.formPromise = this.formService.makePaymentErrr();
  }
}
